/**
 * Kanonische Kapitel-Liste — die EINZIGE Quelle fuer Kapitel-IDs und deutsche
 * Kapiteltitel. Client (client/constants/chapters.ts), Server und Admin leiten
 * sich hiervon ab; bitte keine neuen hartkodierten Kapitel-Tabellen anlegen
 * (vor dem Kapitelumbau 08/2026 gab es fuenf divergierende Kopien).
 *
 * Anzeigenamen in der User-App kommen aus i18n (chapter_<id>_title); dieser
 * deutsche Titel ist fuer Admin-UI, Server-Prompts und Fallbacks.
 */
export interface ChapterMeta {
  id: number;
  titleDe: string;
}

export const CHAPTERS_META: ChapterMeta[] = [
  { id: 1, titleDe: 'Verkehrszeichen & Markierungen' },
  { id: 2, titleDe: 'Vorfahrt & Vorrang' },
  { id: 3, titleDe: 'Abbiegen & Wenden' },
  { id: 4, titleDe: 'Geschwindigkeit & Abstand' },
  { id: 5, titleDe: 'Überholen' },
  { id: 6, titleDe: 'Autobahn & Schnellstraße' },
  { id: 7, titleDe: 'Gefahren & Unfälle' },
  { id: 8, titleDe: 'Beleuchtung & Wetter' },
  { id: 9, titleDe: 'Fahrtüchtigkeit' },
  { id: 10, titleDe: 'Umweltbewusstsein' },
  { id: 11, titleDe: 'Fahrzeugtechnik' },
  { id: 12, titleDe: 'Halten & Parken' },
  { id: 13, titleDe: 'Besondere Verkehrsteilnehmer' },
  { id: 14, titleDe: 'Verkehrsbeobachtung' },
  { id: 15, titleDe: 'Bahnübergänge' },
  { id: 16, titleDe: 'Recht & Führerschein' },
];

export const CHAPTER_COUNT = CHAPTERS_META.length;
export const CHAPTER_IDS: number[] = CHAPTERS_META.map((c) => c.id);
export const CHAPTER_TITLES_DE: Record<number, string> = Object.fromEntries(
  CHAPTERS_META.map((c) => [c.id, c.titleDe])
);
